import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bfa1dda"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "app-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TheHeader = _resolveComponent("TheHeader");
    const _component_router_view = _resolveComponent("router-view");
    const _component_AppOverlay = _resolveComponent("AppOverlay");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TheHeader, {
            onOnSignIn: _ctx.setOverlay,
            onOnSignUp: _ctx.setOverlay,
            onOnAccount: _ctx.setOverlay,
            onOnInfo: _ctx.setOverlay
        }, null, 8, ["onOnSignIn", "onOnSignUp", "onOnAccount", "onOnInfo"]),
        _createVNode(_component_router_view),
        _createVNode(_Transition, { name: "overlay" }, {
            default: _withCtx(() => [
                (_ctx.isVisibleOverlay)
                    ? (_openBlock(), _createBlock(_component_AppOverlay, {
                        key: 0,
                        title: _ctx.overlay.title,
                        srcIcon: _ctx.overlay.srcIcon,
                        body: _ctx.overlay.body,
                        onOnClose: _cache[0] || (_cache[0] = ($event) => (_ctx.isVisibleOverlay = false))
                    }, null, 8, ["title", "srcIcon", "body"]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        })
    ]));
}
